export const ACCOUNT_SETUP_GET_STUDENT_BALANCE =
  'ACCOUNT_SETUP_GET_STUDENT_BALANCE';
export const ACCOUNT_SETUP_STUDENT_BALANCE_ERROR =
  'ACCOUNT_SETUP_STUDENT_BALANCE_ERROR';
export const ACCOUNT_SETUP_POST_STUDENT_BALANCE_SUCCESS =
  'ACCOUNT_SETUP_POST_STUDENT_BALANCE_SUCCESS';
export const ACCOUNT_SETUP_CLEAR_STUDENT_BALANCE_ERROR =
  'ACCOUNT_SETUP_CLEAR_STUDENT_BALANCE_ERROR';
export const ACCOUNT_SETUP_STUDENT_BALANCE_FETCHING =
  'ACCOUNT_SETUP_STUDENT_BALANCE_FETCHING';
export const ACCOUNT_SETUP_STUDENT_BALANCE_SUBMITTING =
  'ACCOUNT_SETUP_STUDENT_BALANCE_SUBMITTING';
export const ACCOUNT_SETUP_STUDENT_BALANCE_RESET =
  'ACCOUNT_SETUP_STUDENT_BALANCE_RESET';



// WEBPACK FOOTER //
// ./src/pages/accountsetup/state/changebalance/types.js